export default __webpack_public_path__ + "static/media/nepal1.aaf3b374.jpg";